import { Box, makeStyles, Typography, useTheme } from '@material-ui/core'
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons'
import { Button } from 'components/facets'
import bssLogo from 'img/bssLogo.png'
import cyberpunkLogo from 'img/cyberpunkLogo.webp'
import dbsLogo from 'img/DBSLogo.png'
import digimonLogo from 'img/digimonLogo.png'
import fabLogo from 'img/FABLogo.png'
import ffLogo from 'img/FFLogo.png'
import gundamLogo from 'img/gundam-logo.webp'
import lorcanaLogo from 'img/lorcanaLogo.png'
import mtgBlackLogo from 'img/mtgLogoBlack.svg'
import onePieceLogoTransparent from 'img/onePieceLogoTransparent.png'
import pokemonLogo from 'img/pokemonLogo.png'
import riftboundLogo from 'img/riftboundLogo.png'
import sorceryLogo from 'img/sorceryLogo.webp'
import swuLogo from 'img/swuLogo.png'
import vanguardLogo from 'img/vanguardLogo.png'
import wsLogo from 'img/WSLogo.png'
import yugiohLogo from 'img/yugiohLogo.png'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export interface SquareButtonProps {
  idGame: number
  counters: {
    singles: number
    uniqueSingles: number
    sealed: number
    uniqueSealed: number
    totalUnique: number
  }
  handleShowFullList: (idGame: number, type: 'singles' | 'accessories') => void
}

export const GameStockBox = ({
  idGame,
  counters,
  handleShowFullList,
}: SquareButtonProps): JSX.Element => {
  const { t } = useTranslation()
  const { palette } = useTheme()
  const [showDetails, setShowDetails] = useState(false)
  const { singles, uniqueSingles, sealed, uniqueSealed, totalUnique } = counters

  const useStyles = makeStyles((theme) => ({
    root: {
      width: '210px',
      backgroundColor: palette.lightBlue,
      borderRadius: 5,
      color: palette.primary.main,
      textAlign: 'center',
      padding: 2,
      [theme.breakpoints.down('sm')]: {
        margin: 'auto',
      },
    },
    details: {
      '&:hover': {
        cursor: 'pointer',
      },
    },
    button: {
      width: '90%',
      backgroundColor: 'white',
      color: palette.primary.main,
      paddingLeft: '16px',
      paddingRight: '16px',
      borderRadius: '0.375rem',
      '&:hover': {
        backgroundColor: 'white',
      },
    },
  }))
  const classes = useStyles()

  const detailsPanel = () => (
    <>
      <Typography variant="h6">{`${t(
        'ptInventory.stockReview.uniqueSingles'
      )}: ${uniqueSingles}`}</Typography>
      <Typography variant="h6">{`${t('ptInventory.stockReview.singles')}: ${singles}`}</Typography>
      <Box marginTop={3} marginBottom={3}>
        <Button className={classes.button} onClick={() => handleShowFullList(idGame, 'singles')}>
          <b>{t('ptInventory.stockReview.seeSinglesList')}</b>
        </Button>
      </Box>

      <Typography variant="h6">{`${t(
        'ptInventory.stockReview.uniqueAccessories'
      )}: ${uniqueSealed}`}</Typography>
      <Typography variant="h6">{`${t(
        'ptInventory.stockReview.accessories'
      )}: ${sealed}`}</Typography>
      <Box marginTop={3} marginBottom={2}>
        <Button
          className={classes.button}
          onClick={() => handleShowFullList(idGame, 'accessories')}
        >
          <b>{t('ptInventory.stockReview.seeAccessoriesList')}</b>
        </Button>
      </Box>
      <Box marginTop={1} onClick={() => setShowDetails(false)} style={{ cursor: 'pointer' }}>
        <KeyboardArrowUp />
      </Box>
    </>
  )

  const logoForGame: {
    [key: number]: string
  } = {
    1: mtgBlackLogo,
    3: yugiohLogo,
    6: pokemonLogo,
    8: vanguardLogo,
    9: ffLogo,
    13: dbsLogo,
    10: wsLogo,
    16: fabLogo,
    17: digimonLogo,
    18: onePieceLogoTransparent,
    19: lorcanaLogo,
    20: bssLogo,
    21: swuLogo,
    22: riftboundLogo,
    23: cyberpunkLogo,
    24: gundamLogo,
    25: sorceryLogo,
  }

  return (
    <Box className={classes.root} data-testid={`gameBox-${idGame}`}>
      <Box>
        <Box marginTop={1}>
          <img src={logoForGame[idGame]} height="50px" />
        </Box>
        <Box marginY={1}>
          <Typography variant="h5">
            <b data-testid="total-unique">{uniqueSingles + uniqueSealed}</b>
            {totalUnique !== uniqueSingles + uniqueSealed && <>/ {totalUnique}</>}
          </Typography>
        </Box>
        <Box marginTop={3}>
          {showDetails ? (
            detailsPanel()
          ) : (
            <Box className={classes.details} onClick={() => setShowDetails(true)}>
              <Typography variant="body1">{t('ptInventory.stockReview.details')}</Typography>
              <KeyboardArrowDown />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  )
}
